export const AVAILABILITY_TABLE = 'availability'
export const CASES_TABLE = 'cases'
export const CLIENTS_TABLE = 'clients'
export const INVOICE_HISTORY_TABLE = 'invoice_history'
export const HOURLY_INVOICE_PAYMENT_TABLE = 'hourly_invoice_payment'
export const MEDIATORS_TABLE = 'mediators'
export const ONBOARDING_TABLE = 'onboarding'
export const PARTICIPANTS_TABLE = 'participants'
export const PAYMENTS_TABLE = 'payments'
export const OUTCOME_CASES_TABLE = 'outcome_cases'
export const COUPONS_TABLE = 'coupons'
export const GOOGLE_SESSIONS_TABLE = 'google_sessions'
export const ZOOM_TABLE = 'zoom'
export const STRIPE_SESSIONS_TABLE = 'stripe_sessions'
export const OUTLOOK_SESSIONS_TABLE = 'outlook_sessions'
export const ODR_CASE_META_DATA_TABLE = 'odr_case_meta_data'
export const EMAIL_LOGS_TABLE = 'email_logs'
export const HOURLY_INVOICE_REMINDER = 'hourly_invoices_reminders'
export const MEDIATOR_SETTINGS_TABLE = 'mediator_settings'
export const MEDIATOR_RELATIONSHIPS_TABLE = 'mediator_relationships'
export const MEDIATOR_UPLOAD_FILES_TABLE = 'mediator_upload_files'
export const MEDIATOR_ADDITIONAL_INFO_TABLE = 'mediator_additional_info'

export const PRICING_TIERS_TABLE = 'pricing_tiers'

export const AI_PROMPTS_TABLE = 'ai_prompts'

export const SYSTEM_COUPON_TABLE = 'system_coupons'

export const SUPABASE_STORAGE_LOCATIONS = {
    MEDIATOR_DOCS: 'upload/mediator_docs',
}
